import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';
import Icon from './Icon';

export default function Disclosure({
  summary,
  defaultOpen = false,
  children,
  className,
  hideIndicator = false,
}: {
  summary: ReactNode;
  defaultOpen?: boolean;
  children?: ReactNode;
  className?: string;
  hideIndicator?: boolean; // TODO maybe make this an `indicator` instead to change between known indicators such as a chevron, or the default x/view
}) {
  return (
    <details
      className={twMerge(
        'group/details bg-surface-container-lowest',
        className,
      )}
      data-component="corso-disclosure"
      open={defaultOpen}
    >
      <summary
        // oxlint-disable-next-line jsx-a11y/prefer-tag-over-role -- browsers will apply this role, but js dom doesn't so makes it hard to test
        role="button"
        className={twMerge(
          'group/summary flex list-none items-center gap-2 rounded-sm subheading-sm text-on-surface marker:hidden [&::-webkit-details-marker]:hidden',
          // focused
          'focus-visible:outline-(length:--state-focused-outline-width) focus-visible:outline-offset-(--state-focused-outline-offset) focus-visible:outline-(color:--state-focused-outline-color)',
        )}
      >
        {summary}
        {!hideIndicator && (
          <span className="ml-auto cursor-pointer body-md text-brand group-hover/summary:underline group-focus-visible/summary:underline">
            <span className="block group-open/details:hidden">View</span>
            <Icon
              icon="XMark"
              title="Close"
              className="hidden size-5 group-open/details:block"
            />
          </span>
        )}
      </summary>
      {children}
    </details>
  );
}
